<script>
  export let item;
</script>

<span class="flex justify-between">
  {#each Object.values(item) as val}
    <span>{val}</span>
  {/each}
</span>
